'use client';
import Link from 'next/link';
import Navbar from '@/components/ui/Navbar';
import Footer from '@/components/ui/Footer';

const CONTACT_EMAIL = 'info@reprintsolution.online';
const LAST_UPDATED = '1 June 2026';

export default function ShippingPolicyPage() {
  return (
    <div className="min-h-screen bg-[#030812] text-white">
      <Navbar />
      <main>
        <section className="border-b border-white/10 bg-[linear-gradient(135deg,#07111f_0%,#0f1f3d_100%)] py-16">
          <div className="container mx-auto max-w-4xl px-4">
            <nav className="mb-6 flex items-center gap-2 text-sm text-slate-400">
              <Link href="/" className="hover:text-white transition">Home</Link>
              <span>/</span>
              <span className="text-white">Shipping Policy</span>
            </nav>
            <h1 className="text-3xl font-black text-white md:text-4xl">Shipping Policy</h1>
            <p className="mt-3 text-slate-400 text-sm">Last updated: {LAST_UPDATED}</p>
          </div>
        </section>

        <section className="py-14">
          <div className="container mx-auto max-w-4xl px-4">
            <div className="space-y-8 text-sm leading-7 text-slate-300">

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Processing Time</h2>
                <p className="mt-3">
                  All orders are processed within <strong className="text-white">1–3 business days</strong> after payment confirmation. Orders placed on weekends or public holidays will be processed on the next business day.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Shipping Methods &amp; Delivery Times</h2>
                <div className="mt-3 overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b border-white/10">
                        <th className="py-2 pr-4 text-left font-bold text-white">Method</th>
                        <th className="py-2 pr-4 text-left font-bold text-white">Estimated Delivery</th>
                        <th className="py-2 text-left font-bold text-white">Cost</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-white/5">
                      <tr>
                        <td className="py-3 pr-4">Standard Shipping</td>
                        <td className="py-3 pr-4">3–7 business days</td>
                        <td className="py-3">Calculated at checkout</td>
                      </tr>
                      <tr>
                        <td className="py-3 pr-4">Express Shipping</td>
                        <td className="py-3 pr-4">1–3 business days</td>
                        <td className="py-3">Calculated at checkout</td>
                      </tr>
                      <tr>
                        <td className="py-3 pr-4">Free Shipping</td>
                        <td className="py-3 pr-4">5–10 business days</td>
                        <td className="py-3">On qualifying orders</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p className="mt-4 text-xs text-slate-400">Delivery times are estimates and not guaranteed. Delays may occur due to carrier issues, weather, or customs.</p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Shipping Regions</h2>
                <p className="mt-3">
                  We currently ship to addresses within the United Kingdom. For international shipping enquiries, please contact us at <a href={`mailto:${CONTACT_EMAIL}`} className="text-violet-400 hover:text-violet-300 underline">{CONTACT_EMAIL}</a>.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Order Tracking</h2>
                <p className="mt-3">
                  Once your order has been dispatched, you will receive a shipping confirmation email with a tracking number. You can use this number to track your order via the carrier&apos;s website.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Damaged or Lost Shipments</h2>
                <p className="mt-3">
                  If your order arrives damaged, please contact us within <strong className="text-white">48 hours</strong> of delivery with photos of the damage and packaging. For lost shipments, please allow the full estimated delivery window to pass before contacting us.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Contact Us</h2>
                <p className="mt-3">
                  For shipping enquiries, contact us at:{' '}
                  <a href={`mailto:${CONTACT_EMAIL}`} className="text-violet-400 hover:text-violet-300 underline">{CONTACT_EMAIL}</a>
                </p>
              </div>

            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
